import React from 'react';
import { Row } from 'styled-bootstrap-grid';
import { styled } from 'styled-components';

import { FormGroup, InnerGroup } from '../FormGroup/index.tsx';

const Wrapper = styled.div`
  display: flex;
`;

export const Fields = styled.div`
  display: flex;
  flex: auto;
`;

export const Counter = styled.div<Pick<IFieldsGroup, '$labelCompensation'>>`
  margin-right: 15px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ $labelCompensation }) => $labelCompensation && '26px'};
`;

export const Actions = styled.div<Pick<IFieldsGroup, '$labelCompensation'>>`
  margin-left: 15px;
  margin-top: ${({ $labelCompensation }) => $labelCompensation && '26px'};
`;

export interface IFieldsGroup {
  $labelCompensation?: boolean;
  $actions?: React.ReactNode;
  children?: React.ReactNode;
  $rowBody?: boolean;
  $wrapperType?: 'inner-group' | 'form-group';
  $counter?: string;
}

const FieldsGroup: React.FC<IFieldsGroup> = ({
  $labelCompensation = true,
  $wrapperType = 'inner-group',
  children,
  $actions,
  $rowBody = true,
  $counter,
}) => (
  <Wrapper as={$wrapperType === 'inner-group' ? InnerGroup : FormGroup}>
    {$counter && <Counter $labelCompensation={$labelCompensation}>{$counter}</Counter>}
    <Fields as={$rowBody ? Row : 'div'}>{children}</Fields>
    {$actions && <Actions $labelCompensation={$labelCompensation}>{$actions}</Actions>}
  </Wrapper>
);

export default React.memo(FieldsGroup);
